import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiError, HttpService } from '../../../services/http.service';
import { ConfigService } from '../../../services/config.service';
import { CustomToastComponent } from '../../toast/custom-toast.component';
import { VideoPlayDialogComponent } from '../video-player/video-dialog.component';

@Component({
    selector: 'app-student-welcome-dialog',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './student-welcome-dialog.component.html',
    styleUrls: ['./student-welcome-dialog.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    encapsulation: ViewEncapsulation.None
})
export class StudentWelcomeDialogComponent implements OnInit {
    label: string = '';
    @ViewChild('lottiePlayer', { static: false }) lottiePlayer!: ElementRef;

    dontShowAgain: boolean = false;
    name: string = '';
    private preloadedVideoUrl: string = '';

    constructor(
        public dialogRef: MatDialogRef<StudentWelcomeDialogComponent>,
        private httpService: HttpService,
        private dialog: MatDialog,
        private snackBar: MatSnackBar,
        private configService: ConfigService,
        @Inject(MAT_DIALOG_DATA) public data: { label: string }
    ) {
        this.label = data?.label ?? '';
    }

    ngOnInit(): void {
        this.configService.getWelcomeVideoUrl().subscribe(url => {
            if (url) this.preloadedVideoUrl = url;
        });
    }

    ngAfterViewInit(): void {
        const UserDetailsStr = localStorage.getItem('userDetails') || '';
        const UserDetails = UserDetailsStr ? JSON.parse(UserDetailsStr) : '';
        this.name = (UserDetails.firstName || '') + ' ' + (UserDetails.lastName || '');
        setTimeout(() => {
            if (this.lottiePlayer && this.lottiePlayer.nativeElement) {
                (this.lottiePlayer.nativeElement as any).stop();
            }
        }, 100);
    }

    close(): void {
        const UserDetailsStr = localStorage.getItem('userDetails') || '';
        const user = JSON.parse(UserDetailsStr)

        if (this.dontShowAgain) {
            this.httpService.put<any>(`auth/dismiss-popup/${user.userId}`, {}).subscribe({
                next: (response: any) => {
                    // console.log(response);
                    // this.showSuccessToast(response.message);
                },
                error: (error: ApiError) => {
                    // console.log(error);
                    this.showErrorToast(error?.message)
                },
            });
        }

        this.dialogRef.close();
    }

    onPlayVideo(): void {
        this.dialog.open(VideoPlayDialogComponent, {
            width: '878px',
            height: '660px',
            maxWidth: '95vw',
            disableClose: true,
            data: { label: 'Student Portal!', videoUrl: this.preloadedVideoUrl }
        });
    }

    onCheckboxChange(value: boolean) {
        this.dontShowAgain = value;

        if (this.dontShowAgain) {
            localStorage.setItem('studentIsFirstLogin', 'false');
        } else {
            localStorage.setItem('studentIsFirstLogin', 'true');
        }
    }

    private showSuccessToast(message: string): void {
        this.snackBar.openFromComponent(CustomToastComponent, {
            data: { message },
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['no-padding-snackbar', 'success-toast'],
        });
    }

    private showErrorToast(message: string | null | undefined): void {
        if (!message) return;
        this.snackBar.openFromComponent(CustomToastComponent, {
            data: { message },
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['no-padding-snackbar', 'error-toast'],
        });
    }
}